export const profileDetailsWrapperStyle = {
	flexWrap: { base: 'wrap', md: 'nowrap' },
	pb: '2rem',
	mb: '2rem',
	borderBottom: '1px solid',
	borderColor: 'gray.600',
};

export const countStyle = {
	pr: '0.25rem',
	fontWeight: '500',
	as: 'span',
};
